export class SetSpinner {
    static readonly type = '[UI] Set Spinner';
    constructor(public payload: boolean) { }
}

export class SetItemScrolledToBottom {
    static readonly type = '[UI] Set Item Scrolled To End';
    constructor(public payload: boolean) { }
}

export class SetFailureOverlay {
    static readonly type = '[UI] Set Failure Overlay';
    constructor(public payload: string) { }
}

export class SetNotificationOverlay {
    static readonly type = '[UI] Set Notification Overlay';
    constructor(public payload: {type:'success' | 'error' | 'info' | 'warning', message:string}) { }
}

export class SetSuccessOverlay {
    static readonly type = '[UI] Set Success Overlay';
    constructor(public payload: string) { }
}

export class SetLanguage {
    static readonly type = '[UI] Set Language';
    constructor(public payload: string) { }
}


export class SelectPlace {
    static readonly type = '[UI] Select Place';
    constructor(public payload: any) { }
}

export class SelectBranch {
    static readonly type = '[UI] Select Branch';
    constructor(public payload: {
        id: number;
        name: string;
        taxRate: number;
      }) { }
}

export class CompanyInfoLoaded{
    static readonly type = '[UI] Company Info Loaded';
    constructor(public payload: boolean) { }
}

